import React from 'react';
import PropTypes from 'prop-types';

import currencyFormat from 'components/Widgets/currencyFormat';

export default function Statistics({ invoices }) {
  const unpaid = invoices.filter((invoice) => invoice.attributes.status === 'created')
    .reduce((sum, invoice) => sum + parseFloat(invoice.attributes.total_price), 0);

  const paid = invoices.filter((invoice) => invoice.attributes.status === 'paid')
    .reduce((sum, invoice) => sum + parseFloat(invoice.attributes.total_price), 0);

  return (
    <div className="row">
      <div className="col-md-4">
        <div className="ibox-content font-20">
          Unpaid:
          {' '}
          <span className="italic text-danger">
            {currencyFormat(unpaid, { currency: 'USD', precision: 0, isShowCurrencyName: false })}
          </span>
        </div>
      </div>
      <div className="col-md-4">
        <div className="ibox-content font-20">
          Paid Total:
          {' '}
          <span className="italic text-green">
            {currencyFormat(paid, { currency: 'USD', precision: 0, isShowCurrencyName: false })}
          </span>
        </div>
      </div>
    </div>
  );
}

Statistics.propTypes = {
  invoices: PropTypes.arrayOf(PropTypes.object).isRequired,
};
